import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy , SimpleChanges, OnChanges} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Utility } from '../shared/utility/utility';
import { AjaxService } from '../services/ajax.service';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import {EmitterService} from '../services/emitter.service';
import { LandingPageComponent } from '../landing-page/landing-page.component';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { StaticPageService } from '../services/static-page.service';

@Component({
  selector: 'app-static-pages',
  templateUrl: './static-pages.component.html',
  styleUrls: ['./static-pages.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class StaticPagesComponent implements OnInit, OnDestroy, OnChanges  {

  isPageAvailable;
  loader = true;
  langCode;
  blockedTerritory:boolean = false;
  @Input() url;
  @Output() closeLandingPage = new EventEmitter<boolean>();
  categoryName: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  
  constructor(
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private ajaxService:AjaxService,
    private utils: Utility,
    private emitterService:EmitterService,
    private staticPageService:StaticPageService
  ) {

    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
      this.getStaticPageData(this.url, this.langCode);
    });

    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
      if (queryParams.get("scrollTo") === "blockedTerritory") {
        this.blockedTerritory = true;
      } else {
        this.blockedTerritory = false;
      }
    });
  }

  ngOnInit() {
    window["prerenderReady"] = false;
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      let url = params["url"] || this.url
      if (url) {
        this.getStaticPageData(url, this.langCode);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url'] && changes['url'].currentValue) {
      this.getStaticPageData(this.url, this.langCode);
    }
  }

  getStaticPageData(url, lang) {
    
    this.url = url;
    this.loader = true;
    if(this.staticPageService.staticPageInfo[this.langCode+url]?.status == 'FAILURE'){
      delete this.staticPageService.staticPageInfo[this.langCode+url];
    }
    if(!this.staticPageService.staticPageInfo[this.langCode+url]){
      this.staticPageService.staticPageInfo[this.langCode+url] = "already call happend";
      Promise.resolve(this.staticPageService.getStaticPageData(lang,url)).then(staticPageData => {
        if(staticPageData['status'] != '"FAILURE"'){
          this.updateStaticPage(staticPageData,url,lang);
          this.staticPageService.staticPageInfo[this.langCode+url]=staticPageData;
          this.emitterService.broadCastStaticPageResponse(true)
        }else{
          delete this.staticPageService.staticPageInfo[this.langCode+url];
        }
      }, err=>{
        delete this.staticPageService.staticPageInfo[this.langCode+url];
      });
    }else if(this.staticPageService.staticPageInfo[this.langCode+url] != 'already call happend'){
      this.updateStaticPage(this.staticPageService.staticPageInfo[this.langCode+url],url,lang)
    }
    
  }
  updateStaticPage(staticPageData,url,lang){
    let self = this;
    this.loader = false;
    if ((staticPageData["errorCode"] === 100464) || !staticPageData["content"]) {
      if (url === 'footer' && lang !== 'en') {
        this.getStaticPageData('footer', 'en');
      } else if (url === 'landing_page') {
        this.emitterService.broadcastLandingpage(false);
      } else {
        this.isPageAvailable = false;
      }
    } else {
      this.isPageAvailable = true;
      let staticPageRespInfo = staticPageData;
      let staticHead = staticPageData["head"].replace(new RegExp('{{site_url}}', 'g'), environment.siteUrl);
      let staticContent = staticPageData["content"].replace(new RegExp('{{site_url}}', 'g'), environment.siteUrl);
      setTimeout(() => {
        if (url !== "footer") {
          this.emitterService.broadCastUpdateMetaInfo({
            title: staticPageRespInfo['metaTitle'], 
            keywords: staticPageRespInfo['metaTags'], 
            description: staticPageRespInfo['metaDescription']
          });
        }

        $("#staticPageHead-" + url).html(staticHead);
        $("#staticPageContent-" + url).html(staticContent);
        if (url === "contact-us") {
          this.setContactUsAccordian();
        }

        if (url === 'landing_page') {
          this.emitterService.broadcastLandingpage(true);
          let landingPageId = document.getElementById('lp_quick_register');
          if (landingPageId) {
            this.utils.addDynamicComponent(landingPageId, LandingPageComponent);
          }
          /** once u get access to banner please change give unique class or id for the button */
          $(".lp-continue-to-site").on('click', () => {
            this.emitterService.broadcastLandingpage(false);
             /*GTM event for current viewing page*/
             this.utils.gtmEvent("currentViewingPage", {
               currentPage: "home"
             });
          });
        }
        this.accordian();
        this.loadFaqPage();
        $(".limits").on("click", () => {
          if (this.utils.isUserLoggedIn()) {
            this.router.navigate([this.langCode + '/setlimits']);
          } else {
            this.router.navigate([this.langCode + '/login'], { queryParams: { toSetLimit: 'setlimits' } });
          }
        })
        $(".limits").css("cursor", "pointer")
        $(".customer-support").on("click", () => {
          this.router.navigate([this.langCode + '/contact']);
        });

        $(".footer-link-subsection a[data-link]").on( "click", function(e) {
          e.preventDefault();
        });

        $(".redirect_path, .routerLinks").on("click", function (e) {
          let link;
          if ($(this).hasClass('routerLinks')) {
            link = $(e.target).attr("data-link");
          } else {
            link = $(this).attr("data-link");
          }
          if ($(this).hasClass("faq_scroll")) {
            self.router.navigate([self.langCode + '/' + link], { queryParams: { scrollTo: 'blockedTerritory' } });
          } else if (link) {
            self.router.navigate([self.langCode + '/' + link]);
          }
        });

        if (this.blockedTerritory === true) {
          this.scrollToID();
        }

        if(url==='footer'){
          this.utils.curcaoEGamingInit();
        }
      });
      window["prerenderReady"] = true;
    }
  }
  setContactUsAccordian(){
    setTimeout(() => {
      $('#accordion-contact .open').click(function () {
        $('#accordion-contact .open').removeClass('open-selected');
        $('#accordion-contact .content-contact').slideUp('fast');
        if ($(this).next().is(':hidden') === true) {
          $(this).addClass('open-selected');
          $(this).next().slideDown('fast');
        }
      });
      $('#accordion-contact .content-contact').hide();
    }, 1);
  }

  // Scroll to
  scrollToID() {
    let headerHeight;
    if(document.body.clientWidth > 992) {
      headerHeight = 140;
    } else {
      headerHeight = 35;
    }
    let offsetVal = $("#blockedTerritory").offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: offsetVal
    }, 400)
  }

  categoryChangeHandler(categoryName) {
    /**This "#faqtitle" ID comes from CMS...we are appending dynamically the
     * active selected category name.
     */
    this.categoryName = categoryName;
    $("#faqtitle").text(categoryName);
  }

  accordian() {
    $(".accordian-title").on('click', function() {
      if($(this).siblings('.accordian-content').is(':hidden') === true) {
        $(this).parents(".accordian_wrap").find(".accordian").removeClass("show-accordian");
        $(this).parent('.accordian').addClass("show-accordian");
      } else {
        $(this).parent('.accordian').removeClass("show-accordian");
      }
    })
  }
  loadFaqPage(){
    // Tabs
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  // Accordian
  
  $(".faq-title--question").on("click", function() {
     
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content")[0].style.display = 'none';
    } else {
      let siblings = $(this).parent().siblings()
      if(siblings && siblings.length){
        siblings.each(i=>{
          siblings[i].children[0].classList.remove('active');
          siblings[i].children[1].style.display='none';
        })
      }
      $(this).addClass("active")
      $(this).siblings(".content")[0].style.display = 'block';
    }
  });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
